import React, { Component, useEffect, useState } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import overlayFactory from "react-bootstrap-table2-overlay";
import { Row, Col, DropdownButton, Dropdown, Spinner } from "react-bootstrap";
import memberService from "app/services/memberService";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { AiFillFileExcel } from "react-icons/ai";
import Swal from "sweetalert2";
import { format } from "date-fns";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Accordion, Button, Card } from "react-bootstrap";
import SearchService from "app/services/SearchService";
import {
  creditLimit,
  creditWithdrawal,
  exportCreditReports,
} from "app/services/paymentService";
import moment from "moment";
import {
  MdDone,
  MdClear,
  MdVpnKey,
  MdSearch,
  MdRefresh,
  MdEdit,
} from "react-icons/md";
import EditReq from "./EditReq";
// import { dateTimeFormat } from "";
import queryStringService from "app/services/queryStringService";
import HandyScroll from "app/common/Scroll";
import { FaCreditCard } from "react-icons/fa";

// const { creditLimit, exportCreditReports } = paymentService;
function CreditLimit() {
  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [FromDate, setFromDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [User, setUser] = useState("");

  const dateFormater = (cell, row) => {
    if (cell) {
      return new moment(cell).format("DD-MM-YYYY");
    }
  };

  const statusFormatter = (cell, row) => {
    if (row.isCreditLock) {
      return <span>Lock</span>;
    } else {
      return <span>Unlock</span>;
    }
  };
  const ledgerCalculation = (cell, row) => {
    const totalLedger = row.balance - row.creditLimit;
    if (totalLedger > 0) {
      return (
        <span style={{ color: "green" }}>{Number(totalLedger).toFixed(2)}</span>
      );
    } else {
      return (
        <span style={{ color: "red" }}>{Number(totalLedger).toFixed(2)}</span>
      );
    }

    // return totalLedger;
  };
  const actionFormatter = (cell, row) => {
    return (
      <>
        <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item
            onClick={() => {
              Swal.fire({
                title: `Credit Withdrawal`,
                html: ` <form autocomplete="off">
               
                <div style="margin-Bottom: 20px;" >
                    <span id="main-balance">${row.company} (${
                  row.uniqueIdentity
                })</span> 
                </div>
              
                <div id="balance-card" class="card" >
                    <div class="card-body">
                        <p class="card-text">Main Balance: <span id="main-balance">${Number(
                          row.balance
                        ).toFixed(2)}</span></p>
                        <p class="card-text">Credit Limit: <span id="credit-limit">${Number(
                          row.creditLimit
                        ).toFixed(2)}</span></p>
                        <p class="card-text">Ledger Balance: <span id="available-balance" style="color: ${
                          row.balance - row.creditLimit > 0
                            ? "green"
                            : row.balance - row.creditLimit === 0
                            ? "black"
                            : "red"
                        }">${Number(row.balance - row.creditLimit).toFixed(
                  2
                )}</span></p>
                    </div>
                </div>
            </form>`,

                showCancelButton: true,
                confirmButtonText: "Proceed",
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async () => {
                  debugger;
                  const MemberId = {
                    memId: row.memId,
                  };

                  const res = await creditWithdrawal(MemberId);
                  console.log(res);
                  return res;
                },
              }).then((result) => {
                if (result.isConfirmed) {
                  if (result.value.status === "Success") {
                    Swal.fire({
                      title: result.value.message,
                      icon: "success",
                    });
                    loadTransaction();
                  } else {
                    Swal.fire({
                      title: result.value.message,
                      icon: "error",
                    });
                  }
                }
              });
            }}
          >
            {/* <Link
              style={{ width: "100%", textDecoration: "none" }}
              className="btn btn-link"
              to={`/admin/merchant/edit/${row.memId}`}
            > */}
            <FaCreditCard
              className="text-primary me-4"
              size={15}
              // style={{ marginLeft: "-70%" }}
            ></FaCreditCard>
            Credit Withdrawal
            {/* </Link> */}
          </Dropdown.Item>
        </DropdownButton>
      </>
    );
  };
  const columns = [
    {
      dataField: "memId",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
    // {
    //   dataField: "memId",
    //   text: "Member Id",
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "120px", textAlign: "center" };
    //   },
    // },
    {
      dataField: "uniqueIdentity",
      text: "Username",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },

    {
      dataField: "memberFullName",
      text: "Name",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "emailId",
      text: "Email",
      headerStyle: (colum, colIndex) => {
        return { width: "250px", textAlign: "center" };
      },
      // formatter: this.balanceFormttter,
    },

    {
      dataField: "memberMobileNo",
      text: "Mobile No",
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "company",
      text: "Company",
      //  formatter: this.dateFormater,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "balance",
      text: "Balance",
      //  formatter: this.dateFormater,status
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "creditLimit",
      text: "Credit Limit",
      //  formatter: this.dateFormater,status
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "memId",
      text: "Ledger Balance",
      formatter: ledgerCalculation,
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
    },
    {
      dataField: "isCreditLock",
      text: "Credit Lock Status",
      //  formatter: this.dateFormater,status
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: statusFormatter,
    },
    {
      dataField: "creditLimitSetDate",
      text: "credit Limit Set Date",
      //  formatter: this.dateFormater,status
      headerStyle: (colum, colIndex) => {
        return { width: "150px", textAlign: "center" };
      },
      formatter: dateFormater,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadTransaction = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      FromDate,
      ToDate,
      UserName: User,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await creditLimit(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };
  useEffect(() => {
    loadTransaction();
  }, [page, sizePerPage]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
  };

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    if (name === "FromDate") setFromDate(value);
    else if (name === "ToDate") setToDate(value);
    else if (name === "User") setUser(value);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setLoading(true);

    await loadTransaction();
  };

  const resetTableHandler = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await creditLimit(query);
    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  const refreshFilter = async () => {
    setTimeout(() => {
      setFromDate("");
      setToDate("");
      setUser("");
      setPage(1);
    }, 10);

    await resetTableHandler();
  };

  const exportTransactionLog = async () => {
    const query = queryStringService.getQueryStringFromObj({
      FromDate,
      ToDate,
      UserName: User,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }

    const response = await exportCreditReports(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${moment().toISOString()}_CreditLog.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setLoading(false);
  };

  const handleExport = async () => {
    setPage(1);
    setSizePerPage(10);
    await exportTransactionLog();
  };

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="me-2">Page Size</label>
      <div className="btn-group me-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Helmet>
        <title>Credit Limit Report</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Credit Limit Report" }]}
      ></Breadcrumb>
      <div className="card card-body mb-3">
        <div className="row">
          <div className="col-md-3 ">
            <div className="input-group mb-3">
              <input
                type="date"
                className="form-control"
                value={FromDate}
                data-date=""
                data-date-format="YYYY-MM-DD"
                name="FromDate"
                onChange={handleSearchChanges}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>
          </div>
          <div className="col-md-3 ">
            <div className="input-group mb-3">
              <input
                type="date"
                className="form-control"
                data-date=""
                data-date-format="YYYY-MM-DD"
                value={ToDate}
                name="ToDate"
                onChange={handleSearchChanges}
                max={moment().format("YYYY-MM-DD")}
              />
            </div>
          </div>
          <div className="col-md-3 ">
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="UserName"
                value={User}
                name="User"
                onChange={handleSearchChanges}
              />
            </div>
          </div>
          <div className="col-md-3 d-flex justify-content-around mb-3">
            <button
              className="btn btn-outline-primary  mr-1"
              onClick={handleSearch}
              type="button"
            >
              search
            </button>
            <button
              className="btn btn-outline-primary mx-1"
              onClick={refreshFilter}
            >
              Refresh
            </button>
            <Button
              variant="outline-primary"
              className="ml-2"
              onClick={handleExport}
              disabled={!dataCount}
            >
              Export
              <AiFillFileExcel className=" ml-2" />
            </Button>
          </div>
        </div>
        <HandyScroll>
          <div
            class="spacious-container"
            data-handy-scroll
            style={{ overflow: "auto" }}
          >
            <BootstrapTable
              hover
              remote
              keyField="uniqueIdentity"
              data={data}
              columns={columns}
              pagination={paginationFactory(paginationOptions)}
              onTableChange={handleTableChange}
              noDataIndication={() => <NoDataIndication />}
              loading={loading}
              // overlay={overlayFactory({
              //   spinner: true,
              //   styles: {
              //     overlay: (base) => ({
              //       ...base,
              //       background: "rgba(120, 120, 120, 0.5)",
              //       zIndex: "1",
              //     }),
              //   },
              // })}
              headerClasses="bg-primary text-white"
              bodyClasses="react-bootstrap-table-next-min-height"
              rowStyle={rowStyle}
            />
          </div>
        </HandyScroll>
      </div>
    </>
  );
}

export default CreditLimit;
